import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { Container, Row, Column } from '@pella/sash-framework';
import { Layout, SEO, Breadcrumbs } from '../../components';

import styles from './index.module.scss';

const PolicyPages = (props) => {
	const pageData = props.data.contentstackPolicyDocuments;
	const pageClass = pageData.title.replace(/\s+/g, '-').toLowerCase();

	return (
		<Layout
			id='template-PolicyPages'
			className={pageClass}
		>
			{pageData.breadcrumbs && (
				<Breadcrumbs
					data={pageData.breadcrumbs}
					currentUrl={pageData.url}
				/>
			)}

			{pageData.page_heading && (
				<div className={styles.policyHero}>
					<Container width={1800}>
						<h1 className='s2-h1__alt'>{pageData.page_heading}</h1>
					</Container>
				</div>
			)}

			{pageData.content_sections?.[0] &&
				pageData.content_sections.map((content, index) => (
					<div
						key={index}
						id={content.anchor ? content.anchor : ''}
						className={styles.policyContent}
					>
						<Container width={1800}>
							<Row justify='between'>
								<Column
									xs={12}
									xl={3}
								>
									{content.heading && <h2 className={styles.policyContent_Title}>{content.heading}</h2>}

									{content.subheading && (
										<div
											dangerouslySetInnerHTML={{
												__html: content.subheading,
											}}
											className={styles.policyContent_Subtitle}
										/>
									)}
								</Column>

								<Column
									xs={12}
									xl={8}
								>
									{content.description && (
										<div
											dangerouslySetInnerHTML={{
												__html: content.description,
											}}
											className={styles.policyContent_Description}
										/>
									)}
								</Column>
							</Row>
						</Container>
					</div>
				))}
		</Layout>
	);
};

PolicyPages.propTypes = {
	data: PropTypes.object,
	location: PropTypes.object,
};

export default PolicyPages;

// eslint-disable-next-line react/prop-types -- fix this
export const Head = ({ data }) => <SEO {...data.contentstackPolicyDocuments.seo} />;

export const query = graphql`
	query ($uid: String!) {
		contentstackPolicyDocuments(id: { eq: $uid }) {
			url
			title

			breadcrumbs {
				active_page
				back_pages {
					...CTA
				}
			}

			page_heading

			content_sections {
				anchor
				heading
				subheading
				description
			}

			seo {
				title
				description
				noIndex: no_index_page
			}
		}
	}
`;
